import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { handleCallback } from '../lib/auth';
import { useAuth } from '../contexts/AuthContext';

export function AuthCallbackPage(): JSX.Element {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { refreshAuth } = useAuth();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const code = searchParams.get('code');
    if (!code) {
      setError('No authorization code received');
      return;
    }
    handleCallback(code).then((success) => {
      if (success) {
        refreshAuth();
        navigate('/dashboard', { replace: true });
      } else {
        setError('Token exchange failed');
      }
    });
  }, [searchParams, navigate, refreshAuth]);

  if (error) {
    return (
      <div className="flex items-center justify-center h-screen" style={{ background: 'var(--bg)' }}>
        <div className="text-center">
          <p className="text-sm" style={{ color: 'var(--red)' }}>
            {error}
          </p>
          <button
            onClick={() => (window.location.href = '/')}
            className="mt-4 text-xs underline"
            style={{ color: 'var(--text-3)' }}
          >
            Try again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center h-screen" style={{ background: 'var(--bg)' }}>
      <div
        className="w-5 h-5 rounded-full border-2 border-t-transparent animate-spin"
        style={{ borderColor: 'var(--border-mid)', borderTopColor: 'var(--accent)' }}
      />
    </div>
  );
}
